module.exports = __webpack_public_path__ + "static/media/Raleway-Black.35e0e2e7.ttf";